import { getAspectRatio } from '@tcp/core/src/utils';

const defaultAspectRatio = {
  aspect_ratio_d: '28',
  aspect_ratio_m: '98',
  aspect_ratio_t: '38',
};

const fillMissingAspectRatios = (mainArray) => {
  const aspectRatios = ['aspect_ratio_d', 'aspect_ratio_m', 'aspect_ratio_t'];

  const compositeImages = mainArray.reduce((acc, obj) => {
    const composites = obj.composites?.largeCompImageSimpleCarouselComposite;
    if (composites) {
      composites.forEach((composite) => {
        if (composite.image) {
          acc.push(composite.image);
        } else if (composite.video) {
          acc.push(composite.video);
        }
      });
    }
    return acc;
  }, []);

  const filledObject = {};

  aspectRatios.forEach((prop) => {
    const filledValue = compositeImages.find((image) => image[prop])?.[prop];
    filledObject[prop] = filledValue || defaultAspectRatio[prop];
  });

  return filledObject;
};

const getAspectRatioFromImage = (image) => {
  return image
    ? {
        aspect_ratio_d: image?.aspect_ratio_d || '28',
        aspect_ratio_m: image?.aspect_ratio_m || '98',
        aspect_ratio_t: image?.aspect_ratio_t || '38',
      }
    : defaultAspectRatio;
};

const calculateAspectRatioModuleContainer = (columns) => {
  const aspectRatio = fillMissingAspectRatios(columns);
  const output = {
    width: {},
    aspectRatio,
    aspectRatioObj: {},
  };

  const getColumnValue = (columnName, key) => {
    let width;
    columns.some((column) => {
      const value = column.set.find((item) => item.key === key)?.val;
      width = value !== undefined && value !== null ? parseFloat(value) : null;
      if (width) return true;
      return false;
    });
    return width;
  };

  // Calculate width values
  ['width', 'widthT', 'widthM'].forEach((key) => {
    const column1Value = getColumnValue(columns, key);
    output.width[key] =
      column1Value !== null && column1Value !== 0 ? parseInt(column1Value, 10) : 100;
  });
  // Calculate aspect ratio object values
  output.aspectRatioObj.aspect_ratio_d =
    (output.width.width * output.aspectRatio.aspect_ratio_d) / 100;
  output.aspectRatioObj.aspect_ratio_t =
    (output.width.widthT * output.aspectRatio.aspect_ratio_t) / 100;
  output.aspectRatioObj.aspect_ratio_m =
    (output.width.widthM * output.aspectRatio.aspect_ratio_m) / 100;
  return output.aspectRatioObj;
};

const getAspectRatioFromObject = (mediaData) => {
  const aspectRatioObject = mediaData ? getAspectRatioFromImage(mediaData) : defaultAspectRatio;
  return getAspectRatio(aspectRatioObject);
};

// eslint-disable-next-line sonarjs/cognitive-complexity
const updateModuleDataWithAspectRatio = (modulesDataCMS) => {
  const updatedModuleData = modulesDataCMS;
  if (modulesDataCMS && typeof modulesDataCMS === 'object') {
    // eslint-disable-next-line complexity
    Object.keys(modulesDataCMS).forEach((moduleID) => {
      const slot = modulesDataCMS[moduleID];
      let aspectRatioObjNew;
      if (slot.moduleName === 'module_container') {
        const aspectRatioObject =
          slot?.allColumns?.length > 0
            ? calculateAspectRatioModuleContainer(slot?.allColumns)
            : defaultAspectRatio;
        aspectRatioObjNew = getAspectRatio(aspectRatioObject);
      }
      if (slot.moduleName === 'moduleD') {
        const mediaData =
          slot?.smallCompImage &&
          (slot?.smallCompImage[0]?.image || slot?.smallCompImage[0]?.video);
        let aspectRatioObject = mediaData ? getAspectRatioFromImage(mediaData) : defaultAspectRatio;
        if (aspectRatioObject?.aspect_ratio_d !== '28') {
          aspectRatioObject = {
            aspect_ratio_d:
              parseInt(aspectRatioObject.aspect_ratio_d, 10) / slot?.smallCompImage.length,
            aspect_ratio_m: parseInt(aspectRatioObject.aspect_ratio_m, 10),
            aspect_ratio_t:
              parseInt(aspectRatioObject.aspect_ratio_t, 10) / slot?.smallCompImage.length,
          };
        }
        aspectRatioObjNew = getAspectRatio(aspectRatioObject);
      }
      if (slot.moduleName === 'moduleB') {
        const mediaData =
          slot.largeCompImage &&
          slot.largeCompImage[0]?.linkedImage &&
          (slot.largeCompImage[0]?.linkedImage[0]?.image ||
            slot.largeCompImage[0]?.linkedImage[0]?.video);
        aspectRatioObjNew = getAspectRatioFromObject(mediaData);
      }
      if (slot.moduleName === 'moduleN') {
        const mediaData = slot?.image || slot?.video;
        aspectRatioObjNew = getAspectRatioFromObject(mediaData);
      }
      if (slot.moduleName === 'moduleA') {
        const mediaData =
          slot?.largeCompImageCarousel &&
          slot?.largeCompImageCarousel[0]?.linkedImage &&
          (slot?.largeCompImageCarousel[0]?.linkedImage[0]?.image ||
            slot?.largeCompImageCarousel[0]?.linkedImage[0]?.video);
        aspectRatioObjNew = getAspectRatioFromObject(mediaData);
      }
      if (slot.moduleName === 'moduleJ') {
        const aspectRatioObject = {
          aspect_ratio_d: '27',
          aspect_ratio_m: '85',
          aspect_ratio_t: '38',
        };
        aspectRatioObjNew = getAspectRatio(aspectRatioObject);
      }
      updatedModuleData[moduleID].aspectRatioObject = aspectRatioObjNew;
    });
  }
  return updatedModuleData;
};

export default updateModuleDataWithAspectRatio;
